export default "<div class=\"bg-dark\">\n    <app-routes-nav [hidden]=\"showRoutesNav === false\" ></app-routes-nav>\n</div>\n\n"